import React from 'react';
import { Typography } from "@material-ui/core";
import {
    objestados,moment
} from '../index.js';
import { RowCopia } from '../../RowCopia.js';

import { Button } from '@material-tailwind/react';

export const PanelEntrevista = ({status_actual_tramite,datosDelTramite,linkEntrevista,accederEntrevista,IniciarCerrarEntrevista,refrescar,usuario}) => {

    return  <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm space-y-4 h-full">
        <div className="flex items-center justify-between border-b border-gray-200 pb-2">
            <Typography variant="small" color="blue-gray" className="font-bold uppercase tracking-wider text-xs text-slate-500">
                Entrevista
            </Typography>
            <div>
                {datosDelTramite?.id_entrevista == undefined ? (
                    <span className="px-2 py-0.5 rounded-full text-[10px] font-black uppercase bg-red-100 text-red-800 tracking-wider">Pendiente</span>
                ) : (
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-black uppercase tracking-wider ${datosDelTramite?.id_entrevista?.activo === true ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                        {datosDelTramite?.id_entrevista?.activo === true ? 'Abierta' : 'Cerrada'}
                    </span>
                )}
            </div>
        </div>

        {status_actual_tramite !== objestados.iniciado.nombre && datosDelTramite?.id_entrevista == undefined && (
            <div className="space-y-3">
                <button onClick={accederEntrevista} className="w-full text-center p-2.5 bg-blue-50/60 hover:bg-blue-50 border border-blue-100 rounded-lg text-blue-600 text-xs font-bold transition-colors">
                    📝 Completar Formulario CRE-15
                </button>
                <RowCopia titulo="Link para el delegado" link={linkEntrevista} versionPlana={true} />
                <p className="text-[10px] text-slate-400 text-center">
                    ¿Ya realizaste la entrevista? <span className='text-blue-500 font-bold cursor-pointer hover:underline' onClick={refrescar}>Actualizar</span>
                </p>
            </div>
        )}

        {datosDelTramite?.id_entrevista && (
            <div className="space-y-3 text-sm">
                <div className="bg-slate-50 p-2.5 rounded-lg border border-slate-100/70 grid grid-cols-2 gap-2 text-xs">
                    <div>
                        <span className="text-slate-400 font-medium block">Fecha:</span>
                        <span className="font-bold text-slate-700">{moment(Number(datosDelTramite?.id_entrevista?.fecha_entrevista)).format('DD/MM/YYYY')}</span>
                    </div>
                    <div>
                        <span className="text-slate-400 font-medium block">Por:</span>
                        <span className="font-bold text-slate-700 truncate block">{datosDelTramite?.id_entrevista?.entrevistador || datosDelTramite?.id_entrevista?.usuario?.nombre}</span>
                    </div>
                </div>
                
                <div className="flex flex-col gap-2 pt-1">
                    {status_actual_tramite !== objestados.iniciado.nombre && (
                        <Button size="sm" color="blue" variant="outlined" className="w-full py-1.5 justify-center" onClick={accederEntrevista}>
                            Visualizar Formulario
                        </Button>
                    )}
                    {datosDelTramite?.id_entrevista?.activo === true && status_actual_tramite==objestados.procRegion.nombre && usuario.perfil == 'region' && 
                    (
                        <Button onClick={IniciarCerrarEntrevista} color="red" size='sm' className="w-full py-1.5 justify-center">
                            Cerrar entrevista
                        </Button>
                    )}
                </div>

                {datosDelTramite?.id_entrevista?.activo === true && (
                    <div className="pt-1">
                        <RowCopia titulo="Reenviar Link" link={linkEntrevista} versionPlana={true}/>
                    </div>
                )}
            </div>
        )}
    </div>

};